import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .large-title {
    color: var(--text-headings, #282A2A);
    font-feature-settings: 'clig' off, 'liga' off;

    font-family: Cadiz, Roboto, arial, sans-serif;
    font-size: 38px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 45.6px */
  }

  .basket-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: row wrap;
    gap: ${csSpacing.spacing06};
    width: 100%;
  }

  .push-right {
    margin-left: auto;
  }
`
